export default "__VITE_ASSET__CMJE2nm0__"